/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { minimumOnboardingPrompts, positionChangeWidthSm, promptsArray } from '../../../../helpers/variableDefaults'
import { descriptionTextField } from '../../../../helpers/textfields'
import { selectElementWithIndex } from '../../../../helpers/selects'
import { standardSpinner } from '../../../../helpers/spinners'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX, addBioItemIconButtonJSX, deleteBioItemIconButtonJSX, promptsElementsJSX } from '../../../../helpers/commonJSX'

export const promptsJSX = (
  bioObject, setBioObject,
  newPrompts, setNewPrompts,
  loadingPrompts, setLoadingPrompts,
  saveSuccessful, setSaveSuccessful,
  bioErrors, setBioErrors,
  width,
  isDemo
) => {

  const showSaveAndCancelButtons = () => {
    // console.log('bioObject.prompts.length ->', bioObject.prompts.length)
    // console.log('all indexes equal ->', bioObject.prompts.filter((promptItem, index) => (promptItem.prompt !== newPrompts[index].prompt || promptItem.response !== newPrompts[index].response)).length)
    // console.log('index 0 equal ->', bioObject.prompts[0].response === newPrompts[0].response)
    // console.log('bioObject.prompts[0].response ->', bioObject.prompts[0].response)
    // console.log('newPrompts[0].response ->', newPrompts[0].response)
    return !(
      newPrompts.length > 0
      && bioObject.prompts.length > 0
      && newPrompts.length === bioObject.prompts.length
      && bioObject.prompts.filter((promptItem, index) => (index > newPrompts.length) || (promptItem.prompt !== newPrompts[index].prompt || promptItem.response !== newPrompts[index].response)).length === 0
    )
  }

  const handleBioItemChange = (e, setErrors, setForm, form, index) => {
    e.preventDefault()

    setBioErrors({ ...bioErrors, prompts: false })
    setSaveSuccessful({ ...saveSuccessful, prompts: false })

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)
    // console.log('index ->', index)

    if (name === 'promptResponse' && value !== ' ') {
      const updatedPromptObj = {
        prompt: newPrompts[index].prompt,
        response: value,
      }
      setForm([ ...newPrompts.map((promptItem, promptItemIndex) => promptItemIndex === index ? updatedPromptObj : promptItem)])
    } else if (name === 'prompt') {
      const updatedPromptObj = {
        prompt: value,
        response: newPrompts[index].response,
      }
      setForm([ ...newPrompts.map((promptItem, promptItemIndex) => promptItemIndex === index ? updatedPromptObj : promptItem)])
    }
  }

  // Add Bio Item JSX
  const addBioItemJSX = (itemType, disabled) => {

    const handleAddItem = () => {
      if (itemType === 'prompts') {

        setBioErrors({ ...bioErrors, prompts: false })
        setSaveSuccessful({ ...saveSuccessful, prompts: false })

        const updatedPrompts = [ 
          ...newPrompts, 
          {
            prompt: '',
            response: '',
          } 
        ]
        setNewPrompts([ ...updatedPrompts ])
      } 
    }

    return (
      <>
        {addBioItemIconButtonJSX(handleAddItem, disabled)}
      </>
    )
  }

  // Delete Bio Item JSX
  const deleteBioItemJSX = (itemType, index, disabled = false) => {
    const handleDeleteBioItem = (e) => {
      e.preventDefault()

      if (!disabled) {
        setBioErrors({ ...bioErrors, prompts: false })
        setSaveSuccessful({ ...saveSuccessful, prompts: false })

        if (itemType === 'prompts') {
          const updatedPrompts = [ ...newPrompts.filter((x, i) => i !== index) ]
          setNewPrompts([ ...updatedPrompts ])
        } 
      }

    }
    return (
      <>
        {deleteBioItemIconButtonJSX(disabled, handleDeleteBioItem, width)}
      </>
    )
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')

    setBioErrors({ ...bioErrors, prompts: false })
    setSaveSuccessful({ ...saveSuccessful, prompts: false })

    setNewPrompts([ ...bioObject.prompts ])
  }

  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')
    const completedPrompts = [ ...newPrompts ].filter((promptItem, index) => (promptItem.prompt.length > 0 && promptItem.response.length > 0))
    while (completedPrompts.length < Math.max(minimumOnboardingPrompts, 3)) {
      completedPrompts.push({
        prompt: '',
        response: '',
      })
    }
    const objectToUpload = {
      prompts: [ ...completedPrompts ],
    }
    // console.log('objectToUpload.prompts ->', objectToUpload.prompts)

    // Upload Modifications
    if (isDemo) {
      setBioObject({ ...bioObject, prompts: [ ...objectToUpload.prompts ] })
      setSaveSuccessful({ ...saveSuccessful, prompts: true })
    } else if (
      objectToUpload.prompts.length > 0 
      && 
      !(
        objectToUpload.prompts.length === bioObject.prompts.length
        && bioObject.prompts.filter((promptItem, index) => (promptItem.prompt !== objectToUpload.prompts[index].prompt || promptItem.response !== objectToUpload.prompts[index].response)).length === 0
      )
      // && objectToUpload.prompts.filter((promptItem, index) => (promptItem.prompt.length === 0 || promptItem.response.length === 0)).length === 0
    ) {
      console.log('attempting upload prompts')
      setLoadingPrompts(true)
      setBioErrors({ ...bioErrors, prompts: false })
      setSaveSuccessful({ ...saveSuccessful, prompts: false })
      
      try {
        // PUT request with updated profile object
        // await axios.put(`/api/users/${userId}`, newForm, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${bioObject._id}`, objectToUpload, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })

        setBioObject({ ...bioObject, prompts: [ ...completedPrompts ] })
        setNewPrompts([ ...completedPrompts ])

        setBioErrors({ ...bioErrors, prompts: false })
        setSaveSuccessful({ ...saveSuccessful, prompts: true })
        setLoadingPrompts(false)
        
      } catch (error) {
        console.log(error)
        setBioErrors({ ...bioErrors, prompts: true })
        setSaveSuccessful({ ...saveSuccessful, prompts: false })
        setLoadingPrompts(false)
      }
    } else {
      handleCancelPressed()
    }
  }
  

  // Prompts JSX
  const promptsJSX = () => {

    return (
      <>
        {promptsElementsJSX(newPrompts, deleteBioItemJSX, handleBioItemChange, setBioErrors, newPrompts, setNewPrompts, width)}
      </>
    )
  }

  return (
    <Box
      sx={{
        py: 3, my: 3,
        width: '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: 3, boxShadow: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* Prompts and Responses Section */}
        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'Prompts', 
          '*Up to 6 prompts and responses',
          0
        )}

        {/* Prompts JSX */}
        {promptsJSX()}

        {/* Add Prompt Button */}
        {addBioItemJSX(
          'prompts',
          (
            newPrompts.length > 5 
            || newPrompts.filter(promptItem => (promptItem.prompt.trim().length === 0 || promptItem.response.trim().length === 0)).length > 0 
            || loadingPrompts
          )
        )}

        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons() &&
          saveAndCancelButtonsJSX(
            loadingPrompts,
            (
              loadingPrompts
              ||
              !(
                (
                  newPrompts.length <= 3
                  &&
                  showSaveAndCancelButtons()
                )
                || 
                  !(
                    newPrompts.length > 3
                    &&
                    newPrompts.filter((promptItem, promptIndex) => promptItem.prompt.length === 0 || promptItem.response.length === 0).length > 0
                  )
              )
            )
            ,
            handleCancelPressed,
            handleSavePressed,
            0,
            bioErrors.prompts ? 0 : 2,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loadingPrompts &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {bioErrors.prompts &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.prompts &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}